// Action Types
export const SET_AVATAR_URL = 'SET_AVATAR_URL'

// Action Creators
export const setAvatarUrl = avatarUrl => ({
  type: SET_AVATAR_URL,
  payload: avatarUrl,
})
